import ko from '@tko/build.knockout';
import _ from 'lodash';
import Vue from 'vue';
import vuetify from '../../plugins/vuetify';
import template from 'raw-loader!./nav-bar.html';
import CommonDialog from '../modal-dialog/common-dialog/common-dialog';
import BrandingService from '../../services/branding.service';
import PermissionService from '../../services/permission.service';
import NavBar from '../../vueComponents/navBar/src/navBar';
import ImpersonationPanel from './impersonationPanel.vue';
import '../../modules/assurance/components/capture/capture';
import LoginService from "../../services/login.service";
import DataProvider from "../../app/data-framework/data-provider";

class NavBarViewModel {
    constructor(params) {
        var self = this;

        const appNameMap = {
          analytics: 'analytics',
          historical2: 'analytics',
          monitoring: 'monitoring',
          rooms: 'workspaces',
          workspaces: 'workspaces',
        };

        self.showOnlyHelp = (params.showOnlyHelp);

        self.capturePage = params.capturePage;
        self.bodyComponent = params.component;

        self.route = params.route;
        self.dataProvider = DataProvider.getInstance();
        self.permissionService = new PermissionService(LoginService.userObject);
        self.appsMenu = params.appsMenu;
        self.sideLinks = ko.unwrap(params.sideLinks);

        self.userObj = LoginService.userObject;

        self.selectedApp = ko.pureComputed(function () {
            if (!self.showOnlyHelp) {
                // migration from old paths
                if (_.includes(window.location.href, '#assurance'))  {
                    return 'monitoring';
                }
                // shadow module
                if (_.includes(window.location.href, '#monitoring') && (_.startsWith(self.userObj.email, 'vyoptaadmin@') || self.userObj.email === 'support@vyopta.com'))  {
                    return 'monitoring';
                }

                let app = _.get(_.find(self.appsMenu(), function (app) {
                    return _.includes(window.location.href, app.url.substring(1));
                }), 'url');
                if (app) {
                  return appNameMap[app.substring(1)];
                }
            } else {
                return '';
            }
        });

        self.enabledApps = [];
        if (typeof self.appsMenu === 'function') {
            self.appsMenu().forEach(function(app) {
                let appName = appNameMap[app.url.substring(1)];
                if(appName && !app.isUpsell) {
                    self.enabledApps.push(appName);
                }
            });
        }

        self.shouldUserSeeCpmAdmin = ko.observable(false);
        if (self.permissionService.hasPermission(self.permissionService.SetupViewPermission)) {
            self.shouldUserSeeCpmAdmin(true);
        }


        self.hiddenG2Toggle = function(data, event) {
            if (self.dataProvider.getCurrentModule() === 'AdvancedAnalytics' || self.dataProvider.getCurrentModule() === 'RoomInsights') {
                let current = sessionStorage.getItem('feature.qe');
                if (!current && LoginService.userObject.farmG2) {
                    sessionStorage.setItem('feature.qe', 'g1.5');
                } else if (current) {
                    sessionStorage.removeItem('feature.qe');
                } else {
                    sessionStorage.setItem('feature.qe', 'g2');
                }
                window.location.reload();
            }
            if (self.dataProvider.getCurrentModule() === '') { // '' = Assurance
                let current = sessionStorage.getItem('feature.events');
                if (current) {
                    console.log("disabling feature.events");
                    sessionStorage.removeItem('feature.events');
                } else {
                    console.log("enabling feature.events");
                    sessionStorage.setItem('feature.events', 'true');
                }
                window.location.reload();
            }
        };

        self.hiddenImpersonate = function(data, event) {
            if (LoginService.userObject.isSu() || LoginService.userObject.isSuPro() ) {
                // open impersonate dialog
                self.navBar.showImpersonate = true;
            }
        };
        
        self.signOut = function() {
            self.dataProvider.signOut();
        };

        self.selectedAppSubscription = self.selectedApp.subscribe(function(val) {
            self.vueDialBack.currentProduct = val;
        });
        self.clearPreferences = function () {
            var self = this;
            let app = _.find(self.appsMenu(), function (app) {
                return _.includes(window.location.href, app.url);
            });
            let clearPrefs = _.get(app, 'clearPrefs');
            let clearPrefsName = _.get(app, 'clearPrefsName');
            let appName = _.get(app, 'name');

            var prompt = "Are you sure you want to clear ALL preferences for "+ clearPrefsName +"?";
            CommonDialog.confirm(prompt).then(function(confirmed) {
                if (confirmed) {
                    clearPrefs(self);
                }
            });
        };
    }

    koDescendantsComplete() {
        let self = this;
        //hack for if side bar is collapsed on login
        self.navBar = new Vue({
            el: '#navBarHook',
            vuetify,
            data: {
                showAdmin: self.shouldUserSeeCpmAdmin(),
                showImpersonate: false,
                capturePage: self.capturePage,
                currentProduct: self.selectedApp(),
                enabledApps: self.enabledApps,
                userName: self.userObj.username,
                userInfo: self.userObj,
                signOut: self.signOut,
                showSidebarToggle: !self.showOnlyHelp,
                showRightSide: !self.showOnlyHelp,
                supportUrl: BrandingService.getSupportUrl(),
                supportContactUrl: BrandingService.getSupportContactUrl(),
                toggleG2: self.hiddenG2Toggle,
                impersonate: self.hiddenImpersonate,
                sideLinks: self.sideLinks,
            },
            methods: {
                reset: function() {
                    this.showImpersonate = false;
                }
            },
            render(h) {
                return h('div', [
                    h(NavBar, {
                        props: {
                            showAdmin: this.showAdmin,
                            currentProduct: this.currentProduct,
                            enabledApps: this.enabledApps,
                            userName: this.userName,
                            userInfo: this.userInfo,
                            showSidebarToggle: this.showSidebarToggle,
                            showRightSide: this.showRightSide,
                            supportUrl: this.supportUrl,
                            supportContactUrl: this.supportContactUrl,
                            sideLinks: this.sideLinks,
                        },
                        on: {
                            'sign-out': this.signOut,
                            'secret-click': this.toggleG2,
                            'secret-meta-click': this.impersonate,
                        },
                    }, [
                        h('span', { slot: 'header' }, [
                            this.capturePage ? h('button', {
                                class: 'assuranceCaptureButton',
                                attrs: {
                                    'data-toggle': 'tooltip',
                                    'data-placement': 'bottom',
                                    title: 'Capture page',
                                },
                                on: { click: this.capturePage }
                            }, [h('i', { class: 'fas fa-camera page-camera' })]) : null
                        ])
                    ]),
                    h(ImpersonationPanel, {
                        props: { show: this.showImpersonate },
                        on: { 'impersonate-complete': this.reset }
                    })
                ]);
            }
        });

    }
    
    dispose() {
        let self = this;
        if (self.selectedAppSubscription) {
            self.selectedAppSubscription.dispose();
        }
        if (self.navBar) {
            self.navBar.$destroy();
            self.navBar.$el.parentNode.removeChild(self.navBar.$el);
        }

    }
}

export default { template: template, viewModel: NavBarViewModel };
